import { defineMessages } from 'react-intl';

const messages = defineMessages({
  paginationLabel: {
    id: 'pgn.DataTable.paginationLabel',
    defaultMessage: 'table pagination',
    description: 'Accessibile name for the navigation element of a pagination component',
  },
});

export default messages;
